/**
 * @ngdoc controllers
 * @memberof mercury.modules.time
 * @name TimePayrunEditspecialCtrl
 */
angular.module('mercury.modules.time.payroll.payrun')
.controller('TimePayrollPayrunEditspecialCtrl', ["$filter", "$scope", "TimePayrollSpecial", function($filter, $scope, TimePayrollSpecial) {
  $scope.loading = TimePayrollSpecial.getAll();
  $scope.loading.then(function(result) {
    $scope.paytypes = result;
  });

  $scope.hasTaxables = function() {
    return $filter('filter')($scope.payrunLine.paytypes, {paytypeIsTaxable: true, paytypeModule: 1}).length > 0;
  };

  $scope.hasNontaxables = function() {
    return $filter('filter')($scope.payrunLine.paytypes, {paytypeIsTaxable: false, paytypeModule: 1}).length > 0;
  };

  $scope.addPaytypeLine = function(type) {
    $scope.payrunLine.paytypes.push({
      paytypeId: type.id,
      paytypeName: type.name,
      paytypeIsTaxable: type.isTaxable,
      paytypeModule: type.module,
      paytypeDefaultQuantity: type.defaultQuantity,
      rate: type.defaultRate,
      quantity: 1
    });

    $scope.updateTotals($scope.payrunLine);
  };

  $scope.removePaytypeLine = function(deletedLine) {
    angular.forEach($scope.payrunLine.paytypes, function(line, index) {
      if (line.paytypeId == deletedLine.paytypeId) {
        $scope.payrunLine.paytypes.splice(index, 1);
      }
    });

    $scope.updateTotals($scope.payrunLine);
  };

  $scope.paytypeOptions = function() {
    var existing = {};
    angular.forEach($scope.payrunLine.paytypes, function(linePaytype) {
      existing[linePaytype.paytypeId] = true;
    });

    var unusedPaytypes = [];
    angular.forEach($scope.paytypes, function(type) {
      if (!existing[type.id]) {
        unusedPaytypes.push(type);
      }
    });

    return unusedPaytypes;
  };

  $scope.rateUpdated = function() {
    $scope.updateTotals($scope.payrunLine);
  };
}]);
